import { z } from "zod";

/**
 * Two languages ship in phase 1 (PRD §5.4). Indonesian copy runs 15–25% longer
 * than English, so every string that reaches the layout is translatable.
 */
export const LOCALES = ["en", "id"] as const;

export const localeSchema = z.enum(LOCALES);
export type Locale = z.infer<typeof localeSchema>;

export const DEFAULT_LOCALE: Locale = "en";

export function isLocale(value: unknown): value is Locale {
  return typeof value === "string" && (LOCALES as readonly string[]).includes(value);
}

/**
 * Rows carry their English copy in real columns and their Indonesian overrides
 * in a `translations` JSON blob, so a missing translation silently falls back
 * to English instead of rendering an empty section.
 */
export const translationsSchema = z
  .record(z.string(), z.record(z.string(), z.unknown()))
  .nullable()
  .optional();

export type Translations = z.infer<typeof translationsSchema>;
